import { render, staticRenderFns } from "./ChallengeForfeitActionMenu.vue?vue&type=template&id=f496fefa&scoped=true&lang=pug&"
import script from "./ChallengeForfeitActionMenu.vue?vue&type=script&lang=js&"
export * from "./ChallengeForfeitActionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeForfeitActionMenu.vue?vue&type=style&index=0&id=f496fefa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f496fefa",
  null
  
)

export default component.exports